export const EMPLOYEE_PORTAL_ROUTE_PATHS = {
  DOCUMENTS: 'documents',
  COMPLIANCE: 'compliance',
  POLICY_SIGN: 'policy/sign',
};

export const EMPLOYEE_PROCESS_DEFINITION_PREFIXES = {
  HR: 'HR3',
  CAREER_REVIEW: 'CR-1',
};
